import { ChangeDetectorRef, Component, computed, inject, Input } from '@angular/core';
import { MenuService } from '../app-menu/app.menu.service';
import {
    CardRadius,
    LayoutService,
    MenuMode,
} from '../service/app.layout.service';
import { DrawerModule } from 'primeng/drawer';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { NgStyle, NgClass } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Drawer } from "primeng/drawer";
import { APP_THEMES, ThemeDefinition, ThemeId } from 'src/themes/themes';

@Component({
    selector: 'app-config',
    templateUrl: './app.config.component.html',
    styleUrl: './app.config.component.scss',
    imports: [
    DrawerModule,
    RadioButtonModule,
    FormsModule,
    NgStyle,
    ButtonDirective,
    NgClass,
    ToggleSwitchModule,
    Drawer
]
})
export class AppConfigComponent {
    @Input() minimal: boolean = false;

    themes = APP_THEMES;

    scales: number[] = [12, 13, 14, 15, 16];

    cd = inject(ChangeDetectorRef);

    constructor(
        public layoutService: LayoutService,
        public menuService: MenuService
    ) {}

    visible = computed(() => this.layoutService.state().configSidebarVisible);
    setVisible(_val: boolean) {
        this.layoutService.state.update((state) => ({
            ...state,
            configSidebarVisible: _val,
        }));

        // detect changes after animation finishes
        setTimeout(() => {
            this.cd.detectChanges();
        }, 310);
    }

    scale = computed(() => this.layoutService.config().scale);
    setScale(_val: number) {
        this.layoutService.config.update((config) => ({
            ...config,
            scale: _val,
        }));
    }

    menuMode = computed(() => this.layoutService.config().menuMode);
    setMenuMode(_val: MenuMode) {
        this.layoutService.config.update((config) => ({
            ...config,
            menuMode: _val,
        }));
        if (
            this.layoutService.isSlim() ||
            this.layoutService.isHorizontal() ||
            this.layoutService.isCompact()
        ) {
            this.menuService.reset();
        }
    }

    inputStyle = computed(() => this.layoutService.config().inputStyle);
    setInputStyle(_val: string) {
        this.layoutService.config.update((config) => ({
            ...config,
            inputStyle: _val,
        }));
    }

    ripple = computed(() => this.layoutService.config().ripple);
    setRipple(_val: boolean) {
        this.layoutService.config.update((config) => ({
            ...config,
            ripple: _val,
        }));
    }

    selectedTheme = computed(() => this.layoutService.config().theme);
    setTheme(id: ThemeId) {
        this.layoutService.config.update((config) => ({
            ...config,
            theme: id,
        }));
    }

    cardRadius = computed(() => this.layoutService.config().cardRadius);
    cardRadiusOptions: { label: string; value: CardRadius }[] = [
        { label: 'Square', value: 'square' },
        { label: 'Small', value: 'small' },
        { label: 'Medium', value: 'medium' },
        { label: 'Large', value: 'large' },
    ];
    setCardRadius(val: CardRadius) {
        this.layoutService.config.update((config) => ({
            ...config,
            cardRadius: val,
        }));
    }

    decrementScale() {
        this.setScale(this.scale() - 1);
    }

    incrementScale() {
        this.setScale(this.scale() + 1);
    }

    private readonly contentBgs: Record<string, string> = {
        light: '#f4f6f8',
        dark: '#252525',
        midnight: '#243447',
        creamy: '#fdf8f0',
        'dtg-dark': '#1f1b14',
        'dtg-light': '#F0EDE8',
    };

    getContentBg(theme: ThemeDefinition): string {
        return this.contentBgs[theme.id] ?? (theme.colorScheme === 'dark' ? '#1e1e1e' : '#f8f9fa');
    }

    getLineBg(theme: ThemeDefinition): string {
        return theme.colorScheme === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.1)';
    }

    restoreDefaults()
    {
        this.layoutService.resetTheme();
    }
}
